import axios from "axios";
import React, { useEffect, useState } from "react";

import { FaRegFileExcel } from "react-icons/fa";
import ImageLoading from "../../components/ImageLoading";

import DownloadLoadingModal from "../../components/DownloadLoadingModal";
import CustomDateModal from "../../components/CustomDateModal";

function ConsolidatedCredit() {
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [userCount, setUserCount] = useState({});
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [openCustomDateModal, setOpenCustomDateModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    name: "",
    report: "",
  });

  const getUserCount = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/consolidated_user_count`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.users_count) {
        setUserCount(res.data.users_count);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleExcelDownload = async (report) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/consolidated?type=excel&file_name=${report}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        handleDownloadFile(res.data.response.data);
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
      console.log(error);
    } finally {
    }
  };

  const handleExcelDownloadForExecution = async (report) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/${report}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log("res",res);

      if (res.data.download_url.status) {
        handleDownloadFile(res.data.download_url.data);
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
      console.log(error);
    } finally {
    }
  };

  const handleExcelDownloadMIS = async (report) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/loan_excel_sheet_report?report_type=${report}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.download_url.status) {
        handleDownloadFile(res.data.download_url.data);
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
      console.log(error);
    } finally {
    }
  };

  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  function formatString(str) {
    if (str === "mf_central") return "MF Central";
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }

  const handlePortfolioDownload = async () => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/all_users_portfolio_excel?download=true`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.download_url.status) {
        handleDownloadFile(res.data.download_url.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    // handleExcelDownload("cibil_report", setCibilUrl, setCibilCount);
    getUserCount();
  }, []);
  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-225px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {/* {noData && (
        <div className="w-full h-[calc(100vh-225px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )} */}
      {!loading && !noData && (
        <div className=" mt-4 w-full overflow-auto max-h-[calc(100vh-205px)] bg-white rounded-lg py-4">
          <div className="flex justify-between text-sm font-semibold px-4">
            <p className="w-[30%]">Reports</p>

            <p className="w-[20%]">Number of Users</p>

            <p className="w-[20%] text-right">Download</p>
          </div>

          <>
            <p className=" text-xs font-semibold mt-6 mb-2 px-4">
              Credit Reporting
            </p>

            <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
              <p className="w-[30%] flex items-center">{"Cibil" || "---"}</p>

              <p className="w-[20%]">
                {userCount?.cibil_report !== null
                  ? userCount.cibil_report
                  : "--"}
              </p>
              <p className="w-[20%] text-right">
                {" "}
                <button
                  className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                  onClick={() => {
                    setSelectedItem({
                      name: "Cibil Report",
                      report: "cibil_report",
                    });
                    setOpenCustomDateModal(true);
                  }}
                >
                  <FaRegFileExcel
                    style={{
                      width: 16,
                      height: 16,
                      color: `${"#00394d"}`,
                      fontWeight: 500,
                    }}
                  />
                </button>
                {/* <button className="p-[3px] border-2 border-[#c6c6c6] rounded">
                        <FaRegFilePdf
                          style={{
                            width: 12,
                            height: 12,
                            color: "#c6c6c6",
                            fontWeight: 500,
                          }}
                        />
                      </button> */}
              </p>
            </div>
          </>
          <>
            <p className=" text-xs font-semibold mt-6 mb-2 px-4">
              Consolidated Earning Report
            </p>

            <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
              <p className="w-[30%] flex items-center">{"Earning" || "---"}</p>

              <p className="w-[20%]">
                {userCount?.earning_report !== null
                  ? userCount.earning_report
                  : "--"}
              </p>
              <p className="w-[20%] text-right">
                {" "}
                <button
                  className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                  onClick={() => {
                    setSelectedItem({
                      name: "Earning Report",
                      report: "earning_report",
                    });
                    setOpenCustomDateModal(true);
                  }}
                >
                  <FaRegFileExcel
                    style={{
                      width: 16,
                      height: 16,
                      color: `${"#00394d"}`,
                      fontWeight: 500,
                    }}
                  />
                </button>
                {/* <button className="p-[3px] border-2 border-[#c6c6c6] rounded">
                        <FaRegFilePdf
                          style={{
                            width: 12,
                            height: 12,
                            color: "#c6c6c6",
                            fontWeight: 500,
                          }}
                        />
                      </button> */}
              </p>
            </div>
            {downloadLoading && <DownloadLoadingModal />}
          </>
          {/* /// */}
          <>
            <p className=" text-xs font-semibold mt-6 mb-2 px-4">
              Loan Against Mutual Funds
            </p>

            <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
              <p className="w-[30%] flex items-center">
                {"Scheme Wise Report" || "---"}
              </p>

              <p className="w-[20%]">
                {userCount?.lamf_consolidated !== null
                  ? userCount.lamf_consolidated
                  : "--"}
              </p>
              <p className="w-[20%] text-right">
                {" "}
                <button
                  className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                  onClick={() => {
                    setSelectedItem({
                      name: "Scheme Wise Report",
                      report: "lamf_consolidated",
                    });
                    setOpenCustomDateModal(true);
                  }}
                >
                  <FaRegFileExcel
                    style={{
                      width: 16,
                      height: 16,
                      color: `${"#00394d"}`,
                      fontWeight: 500,
                    }}
                  />
                </button>
              </p>
            </div>
            <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
              <p className="w-[30%] flex items-center">
                {"Customer Summary Report" || "---"}
              </p>

              <p className="w-[20%]">
                {userCount?.lamf_analytics !== null
                  ? userCount.lamf_analytics
                  : "--"}
              </p>
              <p className="w-[20%] text-right">
                {" "}
                <button
                  className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                  onClick={() => {
                    setSelectedItem({
                      name: "Customer Summary Report",
                      report: "lamf_analytics",
                    });
                    setOpenCustomDateModal(true);
                  }}
                >
                  <FaRegFileExcel
                    style={{
                      width: 16,
                      height: 16,
                      color: `${"#00394d"}`,
                      fontWeight: 500,
                    }}
                  />
                </button>
              </p>
            </div>
            <>
              <p className=" text-xs font-semibold mt-6 mb-2 px-4">
                Execution Report
              </p>
              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Invoke Report" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownloadForExecution(
                        "daily_invoke_execution_report"
                      );
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>
              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Revoke Report" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownloadForExecution(
                        "daily_revoke_execution_report"
                      );
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>
              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Revoke Initiation Report" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownloadForExecution(
                        "daily_revoke_initiation_report"
                      );
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>
            </>

            <>
              <p className=" text-xs font-semibold mt-6 mb-2 px-4">
                Management Information System
              </p>
              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Loan Against Mutual Funds" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownloadMIS("lamf");
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>

              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Loan Against Securities" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownloadMIS("las");
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>
            </>
            <>
              <p className=" text-xs font-semibold mt-6 mb-2 px-4">
                Summary Report
              </p>
              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                <p className="w-[30%] flex items-center">
                  {"Lender Customer Summary Report" || "---"}
                </p>

                <p className="w-[20%]">{"--"}</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handleExcelDownload("lender_customer_summary_report");
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                </p>
              </div>
            </>
            <>
              {/* <p className=" text-xs font-semibold mt-6 mb-2 px-4">Portfolio</p> */}

              <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4 mt-4">
                <p className="w-[30%] flex items-center font-semibold">
                  {"All User Portfolio" || "---"}
                </p>

                <p className="w-[20%]">--</p>
                <p className="w-[20%] text-right">
                  {" "}
                  <button
                    className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center  `}
                    onClick={() => {
                      handlePortfolioDownload();
                    }}
                  >
                    <FaRegFileExcel
                      style={{
                        width: 16,
                        height: 16,
                        color: `${"#00394d"}`,
                        fontWeight: 500,
                      }}
                    />
                  </button>
                  {/* <button className="p-[3px] border-2 border-[#c6c6c6] rounded">
                        <FaRegFilePdf
                          style={{
                            width: 12,
                            height: 12,
                            color: "#c6c6c6",
                            fontWeight: 500,
                          }}
                        />
                      </button> */}
                </p>
              </div>
            </>
            {downloadLoading && <DownloadLoadingModal />}
          </>
        </div>
      )}

      {openCustomDateModal && (
        <CustomDateModal
          selectedItem={selectedItem}
          setShowModal={setOpenCustomDateModal}
        />
      )}
    </>
  );
}

export default ConsolidatedCredit;
